import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentFactoryResolver, Type, ComponentRef } from '@angular/core';
import { Geometry, IGeometry, GeometryType, ConfigurationComponent } from '../models/geometry.model';
import { GeometricLayerComponent } from '../geometric-layer/geometric-layer.component';
import { PointConfigurationComponent } from '../point-configuration/point-configuration.component';
import { PolylineConfigurationComponent } from '../polyline-configuration/polyline-configuration.component';
import { GeometryFactory } from '../factories/geometry.factory';

@Component({
    selector: 'geometry-item',
    templateUrl: './geometry-item.component.html',
    styleUrls: ['./geometry-item.component.scss'],
    standalone: false
})
export class GeometryItemComponent implements OnInit {
    @Input('geometry')
    model:ConfigurationComponent<any>;
    @ViewChild('portal', { read: ViewContainerRef, static: true })
    portal: ViewContainerRef;

    inEdit: boolean = false;
    geometry: Geometry<any>;

    constructor(
        public _layer: GeometricLayerComponent,
        public _factoryResolver: ComponentFactoryResolver
    ) { }

    ngOnInit() {
        if (!(this.model instanceof Geometry))
            this.geometry = GeometryFactory.CreateGeometry(this.model);
        else
            this.geometry = this.model;
    }

    delete() {
        let idx = this._layer.geometry.findIndex(x => x === this.model);

        if (idx !== -1)
            this._layer.geometry.splice(idx, 1);
    }

    edit() {
        this.inEdit = true;
        let component: Type<any> = null;

        switch (this.geometry.type) {
            case GeometryType.Point:
                component = PointConfigurationComponent;
                break;
            case GeometryType.polyline:
                component = PolylineConfigurationComponent;
                break;
        }
        let compRef: ComponentRef<ConfigurationComponent<any>> = this.portal.createComponent(this._factoryResolver.resolveComponentFactory(component));
        compRef.instance.model = this.model;
        compRef.changeDetectorRef.detectChanges();
        compRef.instance.saveChange.subscribe((result) => {
            this.close();
            this.geometry = GeometryFactory.CreateGeometry(this.model);
        });
    }

    close() {
        this.inEdit = false;
        this.portal.clear();
    }
}
